import { useEffect, useState } from 'react';
import charmhealthlogo_placeholder from '../../../../assets/charmhealthlogo_placeholder.jpg';
import { buttonLabels } from '../../../../Constants/Data'
import { useToast } from "../../../../Common/ToastContext";
import { CopyIcon, ExternalLinkIcon, ExpandDropdownIcon, CollapseDropdownIcon } from '../../../../Constants/Icons';

const ListingIcon = ({ listing, seteditProductId, setShowEditListing, handleUnpublishClick }) => {
    const showToast = useToast();

    const handleEditClick = (listing) => {
        seteditProductId(listing.id);
        setShowEditListing(true);
    };

    const styles = {
        container: "h-[25rem] w-full bg-white flex flex-col p-3 shadow-md font-proxima-nova",
        imageContainer: "flex-shrink-0 sm:w-40 sm:h-40 w-28 h-28", // Fixed size for the image container
        textContainer: "flex-1 flex flex-col justify-center min-w-0", // Allows the text to grow but not push the image
        listingName: "text-center text-2xl sm:text-3xl md:text-4xl text-gray font-proxima-nova font-bold opacity-80 break-words whitespace-normal max-w-md line-clamp-2",
        ratingContainer: "mt-4 text-3xl sm:text-3xl text-center inline-flex items-center mx-5 gap-0",
        noReviewText: "mt-2 text-sm sm:text-md text-gray-500 italic text-center font-proxima-nova",
        statusPublished: "mx-2 flex flex-row items-center gap-2 sm:gap-4",
        statusNotPublished: "flex flex-row items-center gap-2 sm:gap-4",
        statusIconPublished: "w-6 h-6 bg-[#3dde02] rounded-full border border-white border-[1px] shadow-md",
        statusIconNotPublished: "w-6 h-6 bg-lightNeutral rounded-full border-white border-[1px] shadow-md",
        statusText: "text-[18px] text-[#505050] font-proximanova",
        updateButton: "text-[18px] font-[600] px-3 sm:px-4 py-1 sm:py-2 text-charmOrange rounded-full whitespace-nowrap font-proximanova underline",
        deleteButton: "close-button-hover text-red text-sm sm:text-lg font-semibold px-3 sm:px-4 py-1 sm:py-2 font-proxima-nova",
        flexRow: "flex flex-row justify-between items-center",
    };

    const getCategoryLabel = (categoryNumber) => {
        const category = buttonLabels.find(btn => btn.number === parseInt(categoryNumber));
        return category ? category.label : categoryNumber.toString();
    };

    const getCategoryColor = (categoryNumber) => {
        const category = buttonLabels.find(btn => btn.number === parseInt(categoryNumber));
        return category ? category.background : categoryNumber.toString();
    };


    const StarFilledIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="#ffa400"
                className="bi bi-star"
                viewBox="0 0 20 20"
            >
                <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 
                    4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8
                    13.187l-4.389 2.256z" />
            </svg>
        );
    };

    const StarEmptyIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="#ffa400"
                className="bi bi-star"
                viewBox="0 0 20 20"
            >
                <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 
                    4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 
                    3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927
                    0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 
                    3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 
                    0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0
                    .393-.288L8 2.223l1.847 3.658a.53.53 0 0 
                    0 .393.288l4.052.575-2.906 2.77a.56.56 0 0
                    0-.163.506l.694 3.957-3.686-1.894a.5.5 0 
                    0 0-.461 0z" />
            </svg>
        );
    };

    const StarHalfIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                fill="#ffa400"
                className="bi bi-star"
                viewBox="0 0 20 20"
            >
                <path d="M5.354 5.119 7.538.792A.52.52 0 0 
                    1 8 .5c.183 0 .366.097.465.292l2.184 
                    4.327 4.898.696A.54.54 0 0 1 16 6.32a.55.55 
                    0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 
                    13.187l-4.389 2.256a.5.5 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 
                    6.765a.55.55 0 0 1-.172-.403.6.6 0 0 1 
                    .085-.302.51.51 0 0 1 .37-.245zM8 12.027a.5.5 0 
                    0 1 .232.056l3.686 1.894-.694-3.957a.56.56 0 
                    0 1 .162-.505l2.907-2.77-4.052-.576a.53.53 0 
                    0 1-.393-.288L8.001 2.223 8 2.226z" />
            </svg>
        );
    };

    const [unpublishModal, setUnpublishModal] = useState(false);

    return (
        <div className="w-full h-[25rem] flex flex-col bg-white p-3 shadow-md relative">
            {unpublishModal && (
                <div className="absolute inset-0 bg-black bg-opacity-50 z-10" />
            )}
            <div className="w-full flex flex-row">
                <div className="w-28 h-28 sm:w-40 sm:h-40 flex-shrink-0 border-2 border-white shadow-md">
                    <img
                        src={listing.thumbnail && listing.thumbnail.includes('.amazonaws.com')
                            ? listing.thumbnail
                            : charmhealthlogo_placeholder}
                        alt="Logo"
                        className={"w-full h-full" + (listing.thumbnail && listing.thumbnail.includes('.amazonaws.com') ? '' : 'border-2 border-lightNeutral')}
                    />
                </div>

                <div className={styles.textContainer}>
                    <div className={styles.listingName}>{listing.name}</div>
                    <div>
                        {listing.rating > 0 ? (
                            <div className={styles.ratingContainer}>
                                {[...Array(5)].map((_, i) => {
                                    const starPosition = i + 1;
                                    const fullStars = Math.floor(listing.rating);
                                    const hasHalfStar = listing.rating - fullStars >= 0.5;

                                    if (starPosition <= fullStars) {
                                        return <StarFilledIcon key={i} />;
                                    } else if (starPosition === fullStars + 1 && hasHalfStar) {
                                        return <StarHalfIcon key={i} />;
                                    } else {
                                        return <StarEmptyIcon key={i} />;
                                    }
                                })}
                                {/* <span className={styles.ratingText}>
                                    {listing.rating} ({listing.totalRatings})
                                    </span> */}
                            </div>
                        ) : (
                            <div className={styles.ratingContainer}>
                                {[...Array(5)].map((_, i) => (
                                    <StarEmptyIcon key={i} />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="mt-3 w-full">
                <div className="flex flex-row overflow-x-auto space-x-2 scrollbar-hide">
                    {listing?.categories?.map((category, index) => (
                        <div
                            key={index}
                            className="w-fit rounded-full px-3 py-1 text-sm whitespace-nowrap flex-shrink-0"
                            style={{ backgroundColor: getCategoryColor(category.id) }}
                        >
                            {getCategoryLabel(category.id)}
                        </div>
                    ))}
                </div>
            </div>


            <p className="mt-3 h-[368px] hidden sm:block text-left text-[18px] overflow-y-auto font-proximanova scrollbar-thin scrollbar-thumb-gray-300 mb-0">
                {listing?.description}
            </p>

            <div className="w-full flex flex-row justify-between items-center">
                {listing.is_published === true ? (
                    <div className="w-fit h-[36px] flex flex-row items-center gap-[4px] relative z-20">
                        <button className="w-[152px] flex flex-row items-center gap-[4px] sm:gap-[12px] bg-white rounded-full px-[12px] py-[6px] border-[1px] border-transparent transition-colors duration-300 delay-100 hover:border-[#505050]" onClick={() => setUnpublishModal(!unpublishModal)}>
                            <div className="w-[18px] h-[18px] bg-[#76da24] rounded-full" />
                            <div className="font-proximanova text-[18px] text-[#505050]">Published</div>
                        </button>

                        {unpublishModal && (
                            <button className="absolute bottom-[40px] w-[152px] flex flex-row items-center gap-[4px] bg-white rounded-full px-[12px] py-[6px] border-[1px] border-transparent transition-colors duration-300 delay-100 hover:border-[#505050]"
                                onClick={() => { setUnpublishModal(false); handleUnpublishClick(listing); }}>
                                <div className="w-[24px] h-[24px] bg-[#fd5764] rounded-full" />
                                <div className="font-proximanova text-[18px] text-[#505050]">Unpublish?</div>
                            </button>
                        )}

                        <a
                            href={`https://www.charmhealthhub.com/explore/${listing.id}`}
                            target="_blank"
                            onClick={(e) => {
                                e.preventDefault();
                                navigator.clipboard.writeText(`https://www.charmhealthhub.com/explore/${listing.id}`);
                                showToast('Link copied to clipboard', `https://www.charmhealthhub.com/explore/${listing.id}`, 'success');
                            }}
                            className='text-charmHover'
                        >
                            <CopyIcon />
                        </a>
                        <a
                            href={`https://www.charmhealthhub.com/explore/${listing.id}`}
                            target="_blank"
                            className='text-charmHover'
                        >
                            <ExternalLinkIcon />
                        </a>
                    </div>
                ) : (
                    <div className="w-fit flex flex-row items-center gap-[4px] sm:gap-[8px]">
                        <div className="flex flex-row items-center gap-[4px] sm:gap-[8px]">
                            <div className="w-[18px] h-[18px] bg-[#fd5764] rounded-full " />
                            <div className="font-proximanova text-[18px] text-[#505050]">Unpublished</div>
                        </div>
                    </div>
                )}

                <div className="w-fit">
                    <button
                        onClick={() => handleEditClick(listing)}
                        className={styles.updateButton}
                    >
                        Update Listing
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ListingIcon;
